import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

const spans = ["sm:col-span-7", "sm:col-span-5 sm:col-start-8", "sm:col-span-6 sm:col-start-3"];

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section id="studio" className="relative z-10 mx-auto max-w-7xl px-6 py-28 sm:py-36" data-testid="manifesto">
      <div className="mb-20 max-w-2xl">
        <p className="mb-3 text-xs uppercase tracking-[0.25em] text-white/50">{t.manifesto.eyebrow}</p>
        <h2 className="font-anton text-5xl sm:text-7xl leading-none tracking-tightest">
          {t.manifesto.heading}
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-y-16 sm:grid-cols-12 sm:gap-y-24">
        {t.manifesto.chapters.map((c, i) => (
          <motion.div
            key={i}
            className={spans[i]}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`chapter-${String(i + 1).padStart(2, "0")}`}
          >
            <span className="font-syne block text-6xl sm:text-8xl font-extrabold text-white/15 leading-none">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="font-syne mt-4 text-2xl sm:text-3xl font-bold text-white">{c.title}</h3>
            <p className="mt-4 max-w-md text-base leading-relaxed text-white/60">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
